import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * PrivateRoute — exige sessão e, quando informado, uma funcionalidade.
 *
 * Onda 41: até aqui a rota só checava se havia sessão. Esconder o item no menu
 * não impedia ninguém de digitar o endereço na barra e abrir a tela inteira —
 * foi assim que os relatórios de acesso, com dados dos moradores, ficaram
 * disponíveis a qualquer usuário autenticado.
 *
 * Onda 43: `roles` deu lugar a `feature`. O papel sozinho não decide mais nada,
 * porque a mesma tela pode existir numa vertical e não existir em outra —
 * Moradores é do condomínio, Tarifas é do estacionamento. Quem decide é o
 * catálogo de permissões do backend, que já chega pronto em `user.features`.
 * Esta verificação é a camada de navegação; a de segurança continua sendo a
 * rota do servidor, que refaz a mesma pergunta.
 *
 *   <PrivateRoute feature="access_reports">…</PrivateRoute>
 */
const PrivateRoute = ({ children, feature }) => {
  const { isAuthenticated, loading, can } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Carregando...</p>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // O Dashboard existe em todas as verticais para todos os perfis, então é
  // sempre um destino válido para quem chegou aqui por endereço digitado.
  if (feature && !can(feature)) return <Navigate to="/dashboard" replace />;

  return children;
};

export default PrivateRoute;
